import { useState, useEffect } from 'react';
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import { Input } from "reactstrap";
import search from "../../assets/images/search.png";
import TopCardsNotification from '../NotificationReport/TopCardsNotification';
import axiosInstance from '../../helpers/axios';
import PaginationTable from '../status/PaginationTable';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import React, { Fragment } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import NotificationMediumReport from "./NotificationHistoryReport/NotificationMediumReport";
import {
  Phone as PhoneIcon,
  Message as MessageIcon,
  Email as EmailIcon,
  WhatsApp as WhatsAppIcon,
  CloudDownload as CloudDownloadIcon
} from '@mui/icons-material';
import { Typography, Button, FormControl, InputLabel, Select, MenuItem, ListSubheader  } from '@mui/material';

export default function NotificationReportV1() {
    const user = null;
    const [sentstartDate,setSentStartDateFrom] = useState()
    const [sentendDate,setSentEndDateTo] = useState()
    const [searchQuery, setsearchQuery] = useState("")
    const [totalFetchRows, setTotalFetchRows] = useState(null);
    const [newtocollection, setNewtocollection] = useState(null);
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [activePage, setActivePage] = useState(15); 
    const [tableData, setTableData] = useState([]); 
    const [isLoading, setIsLoading] = useState(false); 
 
    const [countSMS, setCountSMS] = useState("");
    const [countIVR, setCountIVR] = useState("");
    const [countWhatsapp, setCountWhatsapp] = useState("");
    const [mediumType,setMediumType]=useState('');

    const [showHistoryView, setShowHistoryView] = useState(false);

    // FIXED: Create a centralized function to build query parameters
    const buildQueryParams = (extraParams = {}) => {
        let queryParams = {};
        
        // Handle search fields consistently
        if(searchQuery.startsWith("MCL")){
            queryParams.loanId = searchQuery;
        } else if(searchQuery.startsWith("GBP")){
            queryParams.legacyLoanId = searchQuery;
        } else if(searchQuery.startsWith("FM")){
            queryParams.applicationId = searchQuery;
        } else if(searchQuery){
            // FIXED: Use consistent field name across all functions
            queryParams.mobile = searchQuery;
        }

        // Handle medium type
        if(mediumType){
            queryParams.medium = mediumType;
        }

        // Handle template selection
        if(selectedTemplate && selectedTemplate.trim() !== ''){
            queryParams.type = selectedTemplate;
        }

        // Handle date range
        if(sentstartDate && sentendDate){
            const formattedStartDate = moment(sentstartDate, 'DD MMM YYYY').format('YYYY-MM-DD');
            const formattedEndDate = moment(sentendDate, 'DD MMM YYYY').format('YYYY-MM-DD');
            queryParams.startDate = formattedStartDate;
            queryParams.endDate = formattedEndDate;
        } else {
            // FIXED: Use current date for both start and end when no dates selected
            const currentDate = moment();
            const formattedDate = currentDate.format('YYYY-MM-DD');
            queryParams.startDate = formattedDate;
            queryParams.endDate = formattedDate;
        }

        // Merge any extra parameters
        return { ...queryParams, ...extraParams };
    };

    useEffect(() => {
        setIsLoading(true);
        
        // FIXED: Use centralized query building
        const queryParams = buildQueryParams();
        
        axiosInstance.get('/collection-notification/get-LoanNotification', {
            headers: {
            },
            params: queryParams
        })
        .then((res) => {   
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.currentPage);
            setTotalFetchRows(res?.data?.data?.totalRows);
            setrowsPerPage(res?.data?.data?.perPage);
            setCountSMS(res?.data?.data?.summaryData[0]);
            setCountWhatsapp(res?.data?.data?.summaryData[0]);
            setCountIVR(res?.data?.data?.summaryData[0]);

            const loadingTimeout = setTimeout(() => {
                setIsLoading(false);
            }, 300);
        })
        .catch((error) => {
            setIsLoading(false);
        });
    }, []); 

    const handleChange = (number) => {
        setIsLoading(true);
        setActivePage(number);
        setrowsPerPage(number);

        // FIXED: Use centralized query building with pagination
        const queryParams = buildQueryParams({
            perPage: number,
            pageNo: currentPage
        });

        axiosInstance.get('/collection-notification/get-LoanNotification', {
            params: queryParams,
            headers: {
            },
        })
        .then((res) => {
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.currentPage);
            setTotalFetchRows(res?.data?.data?.totalRows);
            setrowsPerPage(res?.data?.data?.perPage);
            setCountSMS(res?.data?.data?.summaryData[0]);
            setCountWhatsapp(res?.data?.data?.summaryData[0]);
            setCountIVR(res?.data?.data?.summaryData[0]);
 
            const loadingTimeout = setTimeout(() => {
                setIsLoading(false);
            }, 300);
        })
        .catch((error) => {
            alert(error?.response?.data?.message);
            console.error("Error fetching filtered data:", error);
            setIsLoading(false);
        });
    };

    const paginate = (pageNumber) => {
        // FIXED: Use centralized query building with pagination
        const queryParams = buildQueryParams({
            perPage: rowsPerPage,
            pageNo: pageNumber
        });

        axiosInstance.get('/collection-notification/get-LoanNotification', {
            params: queryParams,
            headers: {
            },
        })
        .then((res) => {
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.currentPage);
            setTotalFetchRows(res?.data?.data?.totalRows);
            setrowsPerPage(res?.data?.data?.perPage);
            setCountSMS(res?.data?.data?.summaryData[0]);
            setCountWhatsapp(res?.data?.data?.summaryData[0]);
            setCountIVR(res?.data?.data?.summaryData[0]);
        })
        .catch((error) => {
            alert(error?.response?.data?.message);
            console.error("Error fetching filtered data:", error);
        });
    };

    const fetchingData = () => {
        // history view begin
        setShowHistoryView(true);
        fetchDataBasedOnMedium(cards.SMS.mediumCode);
        fetchDataBasedOnMedium(cards.OBD.mediumCode);
        fetchDataBasedOnMedium(cards.Email.mediumCode);
        fetchDataBasedOnMedium(cards.WhatsApp.mediumCode);
        // history end
        setIsLoading(true);
        
        // FIXED: Use centralized query building
        const queryParams = buildQueryParams();

        axiosInstance.get('/collection-notification/get-LoanNotification', {
            params: queryParams,
            headers: {
            },
        })
        .then((res) => {
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.currentPage);
            setTotalFetchRows(res?.data?.data?.totalRows);
            setrowsPerPage(res?.data?.data?.perPage);
            setCountSMS(res?.data?.data?.summaryData[0]);
            setCountWhatsapp(res?.data?.data?.summaryData[0]);
            setCountIVR(res?.data?.data?.summaryData[0]);
            setIsLoading(false);
        })
        .catch((error) => {
            alert(error?.response?.data?.message);
            console.error("Error fetching filtered data:", error);
            setIsLoading(false);
        });
    };

    // const clearFilter = () => {
    //     // FIXED: Reset all filter states properly
    //     setShowHistoryView(false);
    //     setSentStartDateFrom(null);
    //     setSentEndDateTo(null);
    //     setsearchQuery("");
    //     setMediumType("");
    //     setSelectedTemplate("");
    //     setcurrentPage(1);
    //     setrowsPerPage(15);
    //     setActivePage(15);
        
    //     // FIXED: Reload data instead of entire page
    //     const queryParams = {
    //         startDate: moment().format('YYYY-MM-DD'),
    //         endDate: moment().format('YYYY-MM-DD')
    //     };
        
    //     setIsLoading(true);
    //     axiosInstance.get('/collection-notification/get-LoanNotification', {
    //         headers: {
    //         },
    //         params: queryParams
    //     })
    //     .then((res) => {   
    //         setTableData(res?.data?.data?.data);
    //         setcurrentPage(res?.data?.data?.currentPage);
    //         setTotalFetchRows(res?.data?.data?.totalRows);
    //         setrowsPerPage(res?.data?.data?.perPage);
    //         setCountSMS(res?.data?.data?.summaryData[0]);
    //         setCountWhatsapp(res?.data?.data?.summaryData[0]);
    //         setCountIVR(res?.data?.data?.summaryData[0]);
    //         setIsLoading(false);
    //     })
    //     .catch((error) => {
    //         ;
    //         setIsLoading(false);
    //     });
    // };

    const clearFilter = () => {
  setShowHistoryView(false)
   setSentStartDateFrom(null);
    setSentEndDateTo(null);
    setsearchQuery("");
    setMediumType("");
    setSelectedTemplate("");
  window.location.reload();
};

    const handleCardClick = (type) => {
        setMediumType(type);
        setIsLoading(true);
        
        // FIXED: Use centralized query building with medium type
        const queryParams = buildQueryParams({ medium: type });

        axiosInstance.get('/collection-notification/get-LoanNotification', {
            params: queryParams,
            headers: {
            },
        })
        .then((res) => {
            setTableData(res?.data?.data?.data);
            setcurrentPage(res?.data?.data?.currentPage);
            setTotalFetchRows(res?.data?.data?.totalRows);
            setrowsPerPage(res?.data?.data?.perPage);
            setCountSMS(res?.data?.data?.summaryData[0]);
            setCountWhatsapp(res?.data?.data?.summaryData[0]);
            setCountIVR(res?.data?.data?.summaryData[0]);
            setIsLoading(false);
        })
        .catch((error) => {
            alert(error?.response?.data?.message);
            console.error("Error fetching filtered data:", error);
            setIsLoading(false);
        });
    };

    // Tooltip render function
    function convertISTTimeToAmPmSafe(timeString) {
        if (!timeString || !/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
            return timeString; 
        }

        const [hours, minutes, seconds] = timeString.split(':');
        const date = new Date();
        date.setHours(+hours);
        date.setMinutes(+minutes);
        date.setSeconds(+seconds);

        return date.toLocaleTimeString('en-IN', {
            timeZone: 'Asia/Kolkata',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
    }

    const renderIVRTooltip = (item, index) => {
        const types = item.types?.split(',').map(t => t.trim());
        const callTimes = item.call_times?.split(',').map(t => t.trim());
        const callDurations = item.call_durations?.split(',').map(t => t.trim());
        const callOrderIds = item.call_order_ids?.split(',').map(t => t.trim());

        const tooltipId = `ivr-tooltip-${index}`;
        const hasData = types?.length || callTimes?.length || callDurations?.length || callOrderIds?.length;

        return (
            <>
                <span
                    data-tooltip-id={tooltipId}
                    style={{
                        marginLeft: '6px',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center'
                    }}
                >
                    <InfoOutlinedIcon fontSize="small" style={{ color: '#90caf9' }} />
                </span>

                <ReactTooltip
                    id={tooltipId}
                    place="top"
                    variant="light"
                    style={{
                        backgroundColor: '#f1f9ff',
                        color: '#0d47a1',
                        borderRadius: '6px',
                        padding: '20px',
                        fontSize: '12px',
                        zIndex: 9999,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
                    }}
                >
                    {hasData ? (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ fontWeight: 'bold', textAlign: 'left', borderBottom: '1px solid #ccc' }}>
                                    <th style={{ paddingBottom: '4px', paddingRight: '8px' }}>Type</th>
                                    <th style={{ paddingBottom: '4px', paddingRight: '8px'}}>Time</th>
                                    <th style={{ paddingBottom: '4px', paddingRight: '8px' }}>Duration</th>
                                    <th style={{ paddingBottom: '4px', paddingRight: '8px' }}>Order ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {types?.map((type, i) => (
                                    <tr key={i} style={{ borderBottom: '1px dashed #e0e0e0' }}>
                                        <td style={{ padding: '4px 6px' }}>{type || '-'}</td>
                                        <td style={{ padding: '4px 6px' }}>{convertISTTimeToAmPmSafe(callTimes?.[i]) || '-'}</td>
                                        <td style={{ padding: '4px 6px' }}>{callDurations?.[i] || '-'}</td>
                                        <td style={{ padding: '4px 6px' }}>{callOrderIds?.[i] || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div style={{ fontStyle: 'italic' }}>No data available</div>
                    )}
                </ReactTooltip>
            </>
        );
    };

    // notification history begin
    const [smsData, setSmsData] = useState([]);
    const [ivrData, setIvrData] = useState([]); 
    const [whatsappData, setWhatsappData] = useState([]);
    const [emailData, setEmailData] = useState([]);
    const [emailPagination, setEmailPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        rowsPerPage: 5
    });

    const [smsPagination, setSmsPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        rowsPerPage: 5
    });

    const [whatsappPagination, setWhatsappPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        rowsPerPage: 5
    });

    const [ivrPagination, setIvrPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalRows: 0,
        rowsPerPage: 5
    });

    const [downloadLoading, setDownloadLoading] = useState({
        overall: false,
        1: false, // Email
        2: false, // SMS
        3: false, // WhatsApp
        4: false, // IVR
    });

    const [loadingStates, setLoadingStates] = useState({
        1: false,
        2: false,
        3: false,
        4: false
    });

    const [templateOptions, setTemplateOptions] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');

    const smsFields = [
        { key: 'legacy_loan_id', label: 'Loan ID' },
        { key: 'application_id', label: 'Application ID' },
        { key: 'phone_number', label: 'Mobile' },
        { key: 'type', label: 'Message Type' },
        { key: 'sent_at', label: 'Sent Date', type: 'date' },
        { key: 'sent', label: 'sent'},
    ];

    const ivrFields = [
        { key: 'legacy_loan_id', label: 'Legacy Loan Id' },
        { key: 'loan_id', label: 'Loan Id' },
        { key: 'application_id', label: 'Application ID' },
        { key: 'type', label: 'type' },
        { key: 'phone_number', label: 'Mobile' },
        { key: 'generated_at', label: 'Generated At' },
        { key: 'sent_at', label: 'Sent Date', type: 'date' },
        { key: 'call_order_id', label: 'Call Order ID' },
        { key: 'call_time', label: 'Call Time', type: 'date' },
        { key: 'call_duration', label: 'Call Duration' },
        { key: 'call_id', label: 'Call ID' },
    ];

    const whatsappFields = [
        { key: 'legacy_loan_id', label: 'Legacy Loan Id' },
        { key: 'loan_id', label: 'Loan Id' },
        { key: 'application_id', label: 'Application ID' },
        { key: 'type', label: 'type' },
        { key: 'phone_number', label: 'Mobile' },
        { key: 'generated_at', label: 'Generated At' },
        { key: 'sent_at', label: 'Sent Date', type: 'date' },
        { key: 'sent', label: 'sent'},
        { key: 'delivered', label: 'Delivered' },
        { key: 'read', label: 'Read' }
    ];

    const emailFields = [
        { key: 'legacy_loan_id', label: 'Loan ID' },
        { key: 'application_id', label: 'Application ID' },
        { key: 'sent_at', label: 'Sent Date', type: 'date' },
        { key: 'sent', label: 'Status', type: 'status' }
    ];

    const cards = {
        // WhatsApp: { label: 'WhatsApp', mediumCode: 3 },
         WhatsApp: { label: 'WhatsApp', mediumCode: 5 },
        SMS: { label: 'SMS', mediumCode: 2 },
        OBD: { label: 'OBD', mediumCode: 4 },
        Email: { label: 'Email', mediumCode: 1 }
    };

    const getPaginationConfig = (mediumCode) => {
        switch (mediumCode) {
            case cards.Email.mediumCode:
                return [emailPagination, setEmailPagination];
            case cards.SMS.mediumCode:
                return [smsPagination, setSmsPagination];
            case cards.WhatsApp.mediumCode:
                return [whatsappPagination, setWhatsappPagination];
            case cards.OBD.mediumCode:
                return [ivrPagination, setIvrPagination];
            default:
                return [null, null];
        }
    };

    const setDataByMedium = (mediumCode, data) => {
        if (mediumCode === cards.Email.mediumCode) setEmailData(data);
        if (mediumCode === cards.SMS.mediumCode) setSmsData(data);
        if (mediumCode === cards.WhatsApp.mediumCode) setWhatsappData(data);
        if (mediumCode === cards.OBD.mediumCode) setIvrData(data);
    };

    // fetch templates based on all mediums begin
    useEffect(() => {
        const getAllMediumsTemplates = async () => {
            try {
                const response = await axiosInstance.get('/notification/get-Notification-Templates', {
                    headers: {
                    },
                });
                setTemplateOptions(response.data.data);
            } catch (error) {
                console.error('Error fetching templates:', error);
                setTemplateOptions([]);
            }
        };

        getAllMediumsTemplates();
    }, []);

    // FIXED: Updated fetchDataBasedOnMedium to use centralized query building
    async function fetchDataBasedOnMedium(mediumCode, page = null, rowsPerPage = null) {
        const [pagination, setPagination] = getPaginationConfig(mediumCode);
        if (!pagination) return;

        const currentPage = page ?? pagination.currentPage;
        const perPage = rowsPerPage ?? pagination.rowsPerPage;

        // Set loading state and clear data immediately when starting fetch
        setLoadingStates(prev => ({ ...prev, [mediumCode]: true }));
        
        // Clear current data to show loading state immediately
        setDataByMedium(mediumCode, []);

        // FIXED: Use centralized query building with medium-specific params
        const queryParams = buildQueryParams({
            medium: mediumCode,
            perPage: perPage,
            pageNo: currentPage
        });

        try {
            const response = await axiosInstance.get('/notification/get-History-Notifications', {
                params: queryParams,
                headers: {
                }
            });

            const data = response?.data?.data?.data || [];
            const totalRows = response?.data?.data?.totalRows || data.length;
            const totalPages = Math.ceil(totalRows / perPage);

            setDataByMedium(mediumCode, data);
            setPagination(prev => ({
                ...prev,
                currentPage,
                rowsPerPage: perPage,
                totalRows,
                totalPages
            }));
        } catch (error) {
            console.error('Error fetching data:', error);
            setDataByMedium(mediumCode, []);
            alert(error?.response?.data?.message || 'Failed to fetch data');
        } finally {
            setLoadingStates(prev => ({ ...prev, [mediumCode]: false }));
        }
    }

    const handlePageChange = (mediumCode, page) => {
        const [pagination] = getPaginationConfig(mediumCode);
        if (!pagination) return;
        const [, setPagination] = getPaginationConfig(mediumCode);
        setPagination(prev => ({
            ...prev,
            currentPage: page
        }));
        fetchDataBasedOnMedium(mediumCode, page, pagination.rowsPerPage);
    };

    const handleRowsPerPageChange = (mediumCode, newRowsPerPage) => {
        const [pagination, setPagination] = getPaginationConfig(mediumCode);
        setPagination(prev => ({
            ...prev,
            rowsPerPage: newRowsPerPage,
            currentPage: 1
        }));
        fetchDataBasedOnMedium(mediumCode, 1, newRowsPerPage);
    };

    const handleRefresh = (mediumCode) => {
        fetchDataBasedOnMedium(mediumCode);
    };

    // FIXED: Updated download functions to use centralized query building
    const downloadIndividualReport = async (mediumCode) => {
        setDownloadLoading((prev) => ({ ...prev, [mediumCode]: true }));

        try {
            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = String(currentDate.getFullYear());
            const formattedDate = `${day}-${month}-${year}`;

            // FIXED: Use centralized query building for downloads
            const queryParams = buildQueryParams({ medium: mediumCode });

            const response = await axiosInstance.get("/notification/download-notification-history", {
                params: queryParams,
                responseType: 'arraybuffer',
                headers: {
                }
            });

            // Get medium name for filename
            const mediumNames = {
                1: 'Email',
                2: 'SMS',
                3: 'WhatsApp',
                4: 'IVR'
            };
            
            const mediumName = mediumNames[mediumCode] || 'Notification';
            
            const blob = new Blob([response.data], { type: "application/xlsx" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${mediumName}_Notifications_${formattedDate}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            window.URL.revokeObjectURL(url);
            
        } catch (error) {
            console.error("Error downloading report:", error);
            alert("Error Downloading Individual Report");
        } finally {
            setDownloadLoading((prev) => ({ ...prev, [mediumCode]: false }));
        }
    };

    // FIXED: Updated overall download to use centralized query building
    const downloadOverallReport = async () => {
        setDownloadLoading((prev) => ({ ...prev, overall: true }));

        try {
            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = String(currentDate.getFullYear());
            const formattedDate = `${day}-${month}-${year}`;

            // FIXED: Use centralized query building for overall download
            const queryParams = buildQueryParams();

            const response = await axiosInstance.get("/notification/download-all-notifications", {
                params: queryParams,
                responseType: 'arraybuffer',
                headers: {
                }
            });

            const blob = new Blob([response.data], { type: "application/xlsx" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `All_Notifications_Report_${formattedDate}.xlsx`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            window.URL.revokeObjectURL(url);
            
        } catch (error) {
            console.error("Error downloading overall report:", error);
            alert("Error Downloading Overall Report");
        } finally {
            setDownloadLoading((prev) => ({ ...prev, overall: false }));
        }
    };

    const handleExport = (mediumCode) => {
        downloadIndividualReport(mediumCode);
    };

    const mediumColorMap = {
        Whatsapp: '#40d89f',
        SMS: '#3e7bf0',
        OBD: '#7857f0',
        Email: '#E74C3C',
    };

    return (
        <div style={{width:"100%",backgroundColor:'white'}}>
                <div style={{
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '15px',
                    marginTop: '20px',
                    flexWrap: 'wrap'
                }}>

                    {/* Date Picker */}
                    <div style={{ width: '100%', maxWidth: '250px' }}> 
                        <DatePicker  
                            style={{ 
                                height: '34px',
                                width: '100%',
                                borderRadius: '5px',
                                paddingLeft: '30px',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '5px center',
                                backgroundSize: '15px 15px',
                                backgroundImage: `url(${calender})`,
                                fontSize: '14px',
                                border: '1px solid #ccc'
                            }}
                            placeholder="Select date range"
                            allowClear={true}
                            format="DD MMM YYYY"
                            onChange={(dates, dateStrings) => {
                                setSentStartDateFrom(dateStrings?.validatedValue[0]);
                                setSentEndDateTo(dateStrings?.validatedValue[1]);
                            }}
                            range
                        />
                    </div>

                    {/* Search Input */}
                    <div style={{ width: '100%', maxWidth: '250px' }}>
                        <Input
                            type="text"
                            placeholder="Appl_Id/Loan Id/Mobile"
                            value={searchQuery}
                            onChange={(e) => setsearchQuery(e.target.value)}
                            style={{
                                fontSize: '14px',
                                width: '100%',
                                height: '34px',
                                paddingLeft: '30px',
                                backgroundImage: `url(${search})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '5px center',
                                backgroundSize: '15px 15px',
                                border: '1px solid #ccc',
                                borderRadius: "5px",
                            }}
                        />
                    </div>

                    {/* Template Dropdown */}
                    <FormControl
                        fullWidth
                        size="small"
                        variant="outlined"
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: 2,
                            boxShadow: 1,
                            height: 34,
                            width: 280
                        }}
                    >
                        <InputLabel
                            id="template-select-label"
                            sx={{ fontSize: 13}}
                        >
                            Select Template
                        </InputLabel>
                        <Select
                            labelId="template-select-label"
                            value={selectedTemplate}
                            label="Select Template"
                            onChange={(e) => setSelectedTemplate(e.target.value)}
                            sx={{
                                fontSize: 13,
                                height: 34,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                        >

                            {/* Add Clear Option */}
                                <MenuItem 
                                    value="" 
                                    sx={{ 
                                        fontSize: 13, 
                                        fontStyle: 'italic', 
                                        color: '#666',
                                        borderBottom: '1px solid #eee',
                                        mb: 1
                                    }}
                                >
                                    -- Clear Selection --
                                </MenuItem>

                            {/* Add Clear Option */}
                            {templateOptions.map((medium) => [
                                <ListSubheader
                                    key={medium.medium}
                                    sx={{
                                        bgcolor: mediumColorMap[medium.medium_name] || '#888',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        fontSize: 13,
                                    }}
                                >
                                    {medium.medium_name}
                                </ListSubheader>,
                                ...medium.templates.map((template, index) => (
                                    <MenuItem
                                        key={`${medium.medium}-${index}`}
                                        value={template}
                                        sx={{
                                            pl: 3,
                                            fontSize: 13,
                                            fontweight: 300,
                                        }}
                                    >
                                        {template}
                                    </MenuItem>
                                )),
                            ])}
                        </Select>
                    </FormControl>

                    {/* Search Button */}
                    <div>
                        <button 
                            style={{
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                width: '130px',
                                backgroundColor: '#D22129',
                                height: '34px',
                                border: 'none',
                                borderRadius: "5px",
                                color: 'white',
                                fontFamily: "Inter-Medium",
                                cursor: 'pointer'
                            }}
                            onClick={() => fetchingData()}
                        >
                            Search Results
                        </button>  
                    </div>

                    {/* Clear Filter Button */}
                    <div>
                        <button 
                            style={{
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                width: '130px',
                                backgroundColor: '#D22129',
                                height: '34px',
                                border: 'none',
                                borderRadius: "5px",
                                color: 'white',
                                fontFamily: "Inter-Medium",
                                cursor: 'pointer'
                            }}
                            onClick={() => clearFilter()}
                        >
                           Clear Filter
                        </button>  
                    </div>
                </div>

                {!showHistoryView &&(<TopCardsNotification 
                    countWhatsapp={countWhatsapp} 
                    countSMS={countSMS} 
                    countIVR={countIVR}  
                    onCardClick={handleCardClick}
                />)
}

                {showHistoryView ? (
                    <Box sx={{ p: 3, backgroundColor: '#ffffff', minHeight: '100vh' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                            <Typography variant="h4" gutterBottom sx={{ mb: 0, fontWeight: 600 }}>
                                Notification Reports
                            </Typography>
                            
                            {/* Overall Download Button */}
                            <Button
                                variant="outlined"
                                startIcon={downloadLoading.overall ? <CircularProgress size={16} color="inherit" /> : <CloudDownloadIcon />}
                                onClick={downloadOverallReport}
                                disabled={downloadLoading.overall}
                                sx={{
                                    color:'#000000',
                                    px: 3,
                                    py: 1,
                                    fontSize: '1rem',
                                    fontWeight: 600
                                }}
                            >
                                {downloadLoading.overall ? 'Downloading...' : 'Export All'}
                            </Button>
                        </Box>
                        
                        {/* WhatsApp Report */}
                        <NotificationMediumReport
                            medium={cards.WhatsApp.mediumCode}
                            mediumName="WhatsApp"
                            data={whatsappData}
                            loading={loadingStates[cards.WhatsApp.mediumCode]}
                            fields={whatsappFields}
                            pagination={whatsappPagination}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onRefresh={handleRefresh}
                            onExport={handleExport}
                            mediumColor="#25d366"
                            icon={WhatsAppIcon}
                            downloadLoading={downloadLoading[cards.WhatsApp.mediumCode]}
                        />
                
                        {/* IVR Report */}
                        <NotificationMediumReport
                            medium={cards.OBD.mediumCode}
                            mediumName="IVR"
                            data={ivrData}
                            loading={loadingStates[cards.OBD.mediumCode]}
                            fields={ivrFields}
                            pagination={ivrPagination}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onRefresh={handleRefresh}
                            onExport={handleExport}
                            mediumColor="#9c27b0"
                            icon={PhoneIcon}
                            downloadLoading={downloadLoading[cards.OBD.mediumCode]}
                        />
                        
                        {/* SMS Report */}
                        <NotificationMediumReport
                            medium={cards.SMS.mediumCode}
                            mediumName="SMS"
                            data={smsData}
                            loading={loadingStates[cards.SMS.mediumCode]}
                            fields={smsFields}
                            pagination={smsPagination}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onRefresh={handleRefresh}
                            onExport={handleExport}
                            mediumColor="#1976d2"
                            icon={MessageIcon}
                            downloadLoading={downloadLoading[cards.SMS.mediumCode]}
                        />
                
                        {/* Email Report */}
                        <NotificationMediumReport
                            medium={cards.Email.mediumCode}
                            mediumName="Email"
                            data={emailData}
                            loading={loadingStates[cards.Email.mediumCode]}
                            fields={emailFields}
                            pagination={emailPagination}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            onRefresh={handleRefresh}
                            onExport={handleExport}
                            mediumColor="#ff9800"
                            icon={EmailIcon}
                            downloadLoading={downloadLoading[cards.Email.mediumCode]}
                        />
                    </Box>
                ) : (
                    <div>
                        <table className='tables' style={{ marginRight: '10px', marginTop: '30px' }}>
                            <thead className='table-heading'>
                                <tr>
                                    <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left',height:'10px'  }}>Loan ID</th>
                                    <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left',height:'5px'  }}>Appl. Id</th>
                                    <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left',height:'5px'  }}>Sent date</th>
                                    <th style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'left',height:'5px'  }}>Mobile</th>
                                    
                                    {/* Parent Column: WhatsApp */}
                                    <th colSpan="2" style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'center',height:'5px'  }}>WhatsApp</th>

                                    {/* Parent Column: SMS */}
                                    <th colSpan="2" style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'center',height:'5px'  }}>SMS</th>

                                    {/* Parent Column: OBD */}
                                    <th colSpan="2" style={{ backgroundColor: '#f5f5f5', color: '#4a4a4a', fontWeight: '600', padding: '12px', textAlign: 'center',height:'5px'  }}>OBD</th>
                                </tr>

                                {/* Subheaders for WhatsApp, SMS, and OBD */}
                                <tr>
                                    <th colSpan="4" style={{height:'5px' }}></th>
                                    
                                    {/* Sub-columns under WhatsApp */}
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Attempted</th>
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Success</th>

                                    {/* Sub-columns under SMS */}
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Attempted</th>
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Success</th>

                                    {/* Sub-columns under OBD */}
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Attempted</th>
                                    <th style={{ backgroundColor: '#f9f9f9', color: '#4a4a4a', padding: '10px', textAlign: 'left',height:'5px' }}>Success</th>
                                </tr>
                            </thead>

                            {isLoading ? (
                                <tbody>
                                    <tr>
                                        <td colSpan="10">
                                            <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                                                <CircularProgress />
                                            </Box>
                                        </td>
                                    </tr>
                                </tbody>
                            ) : (
                                <tbody className='table-body'>
                                    {tableData?.map((item, index) => (
                                        <Fragment key={index}>
                                            <tr className="table-row" key={index} style={{ lineHeight:"25px"}}>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.legacy_loan_id}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.application_id}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.sent_date}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.phone_number}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '11em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.Whatsapp}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '11em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.WhatsappSuccess}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '8em', fontFamily: "Inter-Medium", color: '#667085'}}>{item.SMS}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.SMSSuccess}</td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '8em', fontFamily: "Inter-Medium", color: '#667085'}}>
                                                    <span style={{fontSize: '14px',cursor: 'pointer',width: '10em',fontFamily: 'Inter-Medium',color: '#667085',paddingLeft: '10px',display: 'inline-flex',alignItems: 'center',gap: '4px'}}>
                                                        {item?.IVR}{renderIVRTooltip(item, index)}
                                                    </span>
                                                </td>
                                                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item?.IVRSuccess}</td>
                                            </tr>
                                        </Fragment>
                                    ))}
                                </tbody>
                            )}
                        </table>
                
                        {totalFetchRows > 15 ? 
                            <>
                                {totalFetchRows ? ( totalFetchRows <= 100 ?(
                                    <div style={{display:"flex" ,justifyContent:"center",marginTop:"10px"}}>
                                        <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '14px',marginLeft:'10px',marginBottom:'5px' }}>
                                            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
                                            records of {totalFetchRows} |
                                        </div>
                                        <div style={{display:"flex", justifyContent:"space-between",}}>
                                            &nbsp;<p style={{fontWeight:'700'}}>Rows Per Pages :</p>
                                            <div>
                                                <span onClick={()=>handleChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
                                                <span onClick={()=>handleChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
                                                <span onClick={()=>handleChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
                                                <span onClick={()=>handleChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
                                            </div>
                                        </div>
                                    </div>
                                ):( 
                                    <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}>
                                        <div style={{ textAlign: 'center',fontWeight: 'bold',justifyContent:"space-between",fontFamily:"Inter-Medium", fontSize: '14px',marginLeft:'10px',marginBottom:'5px',marginRight:'10px'}}>
                                            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length} {" "}
                                            records of {totalFetchRows} |
                                        </div>
                                        <div style={{display:"flex", justifyContent:"space-between",}}>
                                            <p style={{fontWeight:'700'}}>Rows Per Pages :</p>
                                            <div>
                                                <span onClick={()=>handleChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
                                                <span onClick={()=>handleChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
                                                <span onClick={()=>handleChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
                                                <span onClick={()=>handleChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
                                            </div>
                                        </div>
                                    </div> 
                                )) : (
                                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
                                )}
                            </> : ""
                        }
                        
                        <PaginationTable
                            startPage={currentPage}
                            rowsPerPage={rowsPerPage}
                            totalRows={totalFetchRows}
                            handleChange={handleChange}
                            paginate={paginate}
                            sentstartDate={sentstartDate}
                        />
                    </div>
                )}
        </div>
    );
}